import { render, staticRenderFns } from "./segmentosEditar.vue?vue&type=template&id=76fced8c&scoped=true&"
import script from "./segmentosEditar.vue?vue&type=script&lang=js&"
export * from "./segmentosEditar.vue?vue&type=script&lang=js&"
import style0 from "./segmentosEditar.vue?vue&type=style&index=0&id=76fced8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fced8c",
  null
  
)

export default component.exports